<backbone>
  <section header-page="topbar" class="d-flex justify-content-between gap-2 h-100 position-relative">
    <div class="d-flex justify-content-start align-items-center text-truncate">
      <p class="m-0 fw-medium text-truncate">Constancias no inhabilitación</p>
    </div>

    <div class="d-flex justify-content-end align-items-center gap-3">
      <breadcrumb [items]="[{ label: 'Antecedentes' }, { label: 'Constancias no inhabilitación' }]" />
    </div>
  </section>

  <section wrapper>
    <div [formGroup]="formUpload" class="page-section card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <label>Generar Constancia.</label>
        <p-button label="Generar Constancia" [loading]="isSaving" (onClick)="generate()" [disabled]="!this.formUpload.valid" />
      </div>

      <div class="card-body d-flex flex-column gap-3">
        <div class="row">
          <div class="col-12 col-sm-4">
            <div class="mb-3 mb-sm-0 flex flex-column gap-2">
              <input placeholder="Nombre completo" formControlName="name" type="text" pInputText class="w-100 h-50px" />
              <small class="ps-2"><span class="text-danger">Requerido *</span></small>
            </div>
          </div>
          <div class="col-12 col-sm-4">
            <div class="mb-3 mb-sm-0 flex flex-column gap-2">
              <p-inputMask formControlName="curp" mask="******************" placeholder="CURP" styleClass="w-100 h-50px"></p-inputMask>
              <small class="ps-2"><span class="text-danger">Requerido *</span></small>
            </div>
          </div>
          <div class="col-12 col-sm-4">
            <div class="flex flex-column gap-2">
              <p-inputMask formControlName="rfc" mask="aaaa999999" placeholder="RFC" styleClass="w-100 h-50px"></p-inputMask>

              <small class="ps-2"><span class="text-danger">Requerido *</span></small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="page-section card">
      <div class="card-body p-0">
        <p-table
          #dt1
          [value]="this.list"
          dataKey="id"
          [rows]="25"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[25, 50, 100]"
          [paginator]="true"
          [globalFilterFields]="['name', 'curp', 'rfc']"
        >
          <ng-template pTemplate="caption">
            <p-inputgroup>
              <p-iconfield class="w-100">
                <p-inputicon styleClass="pi pi-search" />
                <input
                  type="text"
                  pInputText
                  [(ngModel)]="searchValue"
                  (input)="dt1.filterGlobal(searchValue, 'contains')"
                  placeholder="Buscar por nombre, curp, rfc."
                  class="w-100 h-50px rounded-end-0"
                />
              </p-iconfield>
              <p-inputgroup-addon *ngIf="searchValue" pTooltip="Limpiar busqueda">
                <p-button icon="pi pi-times" severity="secondary" class="h-100" styleClass="h-100" (click)="searchValue = ''; dt1.filterGlobal(searchValue, 'contains')" />
              </p-inputgroup-addon>
            </p-inputgroup>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th>Nombre</th>
              <th>CURP</th>
              <th>RFC</th>
              <th colspan="2">FECHA</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr>
              <td class="text-nowrap">{{ item.name }}</td>
              <td class="text-nowrap">{{ item.curp }}</td>
              <td class="text-nowrap">{{ item.rfc }}</td>
              <td class="text-nowrap">{{ item.dateCreated | date : "longDate" }}</td>
              <td class="text-nowrap text-end">
                @if (item.download === 0) {
                <a
                  href="{{ apiUrl }}/v1/antecedente/no-inhabilitacion/download/{{ item.foil }}"
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  class="p-button text-decoration-none p-button-success"
                  (click)="item.download = 1"
                >
                  <i class="pi pi-download"></i>
                </a>
                } @else {
                <a href="{{ apiUrl }}/v1/antecedente/no-inhabilitacion/download/{{ item.foil }}" download target="_blank" rel="noopener noreferrer" class="p-button text-decoration-none">
                  <i class="pi pi-download"></i>
                </a>
                }
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="5">No se encontraron registros.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </section>
</backbone>
